<template>
  <b-modal
    :title="title"
    size="xl"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    v-model="show"
    modal-class="confirm-bono"
    @hidden="$emit('close')"
  >
    <div v-if="previewData.length" class="preview-container">
      <div
        v-for="(empleado, index) in previewData"
        :key="index"
        class="employee-row"
      >
        <h5 class="employee-name">
          {{ empleado.nombre || `Empleado #${index + 1}` }}
        </h5>

        <b-row class="cards-row">
          <b-col
            v-for="(caja, i) in empleado.cajas"
            :key="i"
            cols="12"
            md="4"
            class="d-flex"
          >
            <div class="payroll-card flex-fill">
              <h6 class="card-title text-capitalize">
                {{ caja.tipo }}
              </h6>
              <div class="card-body">
                <p><strong>Monto:</strong> {{ caja.monto | currencyZero }}</p>
                <p>
                  <strong>Motivo:</strong>
                  {{ caja.id_motivo_caja | motivoCajaPlanilla }}
                </p>
                <p>
                  <strong>Submotivo:</strong>
                  {{ caja.id_submotivo_caja | submotivoCajaPlanilla }}
                </p>
                <p>
                  <strong>Cuenta Empresa:</strong>
                  {{ caja.id_cuenta_bancaria_empresa | cuentaBancariaFullData }}
                </p>
                <p v-if="caja.descripcion">
                  <strong>Descripción:</strong> {{ caja.descripcion }}
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="actions mt-3">
        <button class="btn btn-secondary" @click="$emit('close')">
          Cancelar
        </button>
        <button class="btn btn-primary" @click="$emit('confirmed')">
          Confirmar Aprobación
        </button>
      </div>
    </div>

    <div v-else class="text-center text-muted py-5">
      <b-spinner small></b-spinner>
      <p class="mt-2">Cargando previsualización...</p>
    </div>
  </b-modal>
</template>

<script>
import AdministrativePayrollService from "@/views/rrhh/views/payroll/services/administrative-payroll.service.js";
import { mapGetters } from "vuex";
// import PayrollService from "@/views/rrhh/views/payroll/services/payroll.service.js";
import BonoService from "@/views/rrhh/views/payroll/components/bonos/service/bono.service.js";

export default {
  props: {
    idBonos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      previewData: [],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    title() {
      return "Confirmacion de Bono";
    },
  },
  mounted() {
    this.getPrevisualizacion();
  },
  methods: {
    async getPrevisualizacion() {
      this.addPreloader();
      try {
        const payload = {
          simular: true,
          bonos: this.idBonos.map((p) => ({
            user_id: this.currentUser.id,
            bono_id: p.bono_id,
          })),
        };
        let data;


        const response = await BonoService.aprobarBono(
          payload,
        );
        data = response.data;

        const transformed = data.data.map((item) => {
          const cajas = Object.keys(item).map((tipo) => {
            const c = item[tipo];
            return {
              tipo,
              employee_id: c.employee_id,
              employee: c.employee,
              monto: c.monto,
              descripcion: c.description,
              id_motivo_caja: c.id_motivo_caja,
              id_submotivo_caja: c.id_submotivo_caja,
              id_cuenta_bancaria_empresa: c.id_cuenta_bancaria_empresa,
            };
          });

          return {
            nombre: cajas[0]?.employee || "Empleado sin nombre",
            cajas,
          };
        });

        this.previewData = transformed;
      } catch (error) {
        const response = error.response?.data;

        if (response?.msg) {
          this.showToastError(response.msg);
        } else if (error.message) {
          this.showToastError(error.message);
        } else {
          this.showToastError("Ocurrió un error inesperado");
        }
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.confirm-bono {
  .preview-container {
    padding: 1rem 1.25rem;
    max-height: 70vh;
    overflow-y: auto;
    scrollbar-width: thin;
    background-color: #f9fafb;

    .employee-row {
      margin-bottom: 1.5rem;
      padding: 1rem;
      background: #ffffff;
      border-radius: 0.75rem;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      transition: box-shadow 0.2s ease;

      &:hover {
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
      }

      .employee-name {
        font-weight: 600;
        font-size: 1rem;
        margin-bottom: 0.75rem;
        color: #0d6efd;
        border-bottom: 1px solid #e9ecef;
        padding-bottom: 0.3rem;
      }

      .cards-row {
        margin: 0 -0.25rem;
      }

      .payroll-card {
        background: #fefefe;
        border-radius: 0.75rem;
        border: 1px solid #e0e0e0;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
        padding: 0.8rem;
        width: 100%;
        font-size: 0.85rem;
        // transition: all 0.2s ease-in-out;

        // &:hover {
        //   transform: translateY(-2px);
        //   box-shadow: 0 2px 8px rgba(13, 110, 253, 0.15);
        // }

        .card-title {
          font-weight: 600;
          font-size: 0.9rem;
          color: #212529;
          text-align: center;
          margin-bottom: 0.5rem;
          text-transform: capitalize;
          border-bottom: 1px solid #dee2e6;
          padding-bottom: 0.25rem;
        }

        .card-body {
          font-size: 0.8rem;
          color: #495057;

          p {
            margin-bottom: 0.3rem;
            line-height: 1.35;
          }

          strong {
            font-weight: 600;
            color: #212529;
          }
        }
      }
    }

    .actions {
      display: flex;
      justify-content: flex-end;
      gap: 0.75rem;
      margin-top: 0.5rem;
      border-top: 1px solid #e9ecef;
      padding-top: 0.75rem;
    }
  }
}

.dark-layout {
  .confirm-bono {
    .preview-container {
      background-color: #1e1e1e;

      .employee-row {
        background: #2c2c2c;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

        .employee-name {
          color: #66b2ff;
          border-bottom: 1px solid #444;
        }

        .payroll-card {
          background: #2a2a2a;
          border: 1px solid #444;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);

          .card-title {
            color: #e0e0e0;
            border-bottom: 1px solid #555;
          }

          .card-body {
            color: #ccc;

            strong {
              color: #e0e0e0;
            }
          }
        }
      }

      .actions {
        border-top: 1px solid #444;
      }
    }
  }
}
</style>
